import styled from 'styled-components';

export const ErrorState = styled.div`
    display: flex;
    min-height: 240px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: var(--space-3, 12px);
    padding: var(--space-6, 24px);
`;

export const ErrorTitle = styled.h2`
    margin: 0;
    color: var(--color-foreground);
    font-size: var(--font-size-lg, 18px);
    font-weight: var(--font-weight-semibold, 650);
`;

export const ErrorCopy = styled.p`
    margin: 0;
    color: var(--color-muted-foreground);
    font-size: var(--font-size-sm, 13px);
`;
